module.exports = __webpack_public_path__ + "img/checkSolutions.b9055929.png";